import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { IUserInfo } from '../model/userinfo.model';
import { ICItem } from '../model/cart.model';
import { IProduct } from '../model/model/product.model';


@Injectable()
export class AppService {

    private updateLangugesubject = new Subject<string>();
    private updateDiseaseId =new Subject<any>();
    private updateProductSubject = new Subject<IProduct>();
    private updateUsersubject = new Subject<IUserInfo>();
    private updateAreaSubject = new Subject<boolean>();
    private userloginSubject = new Subject<boolean>();
    private updateCartSubject = new Subject<boolean>();
    private updateCartStatusSubject = new Subject<ICItem>();

    constructor() { }

      // tslint:disable-next-line:typedef
  getCurrentUserInfo() {
    return this.updateUsersubject.asObservable();
  }

  // tslint:disable-next-line:typedef
  setCurrentUserInfo(user: IUserInfo) {
    this.updateUsersubject.next(user);
  }


    getcurrentLanguage() {
        return this.updateLangugesubject.asObservable();
    }

    setcurrentLanguage(status: string) {
        this.updateLangugesubject.next(status);
    }
      // tslint:disable-next-line:typedef
  getUserLogin() {
    return this.userloginSubject.asObservable();
  }

  // tslint:disable-next-line:typedef
  setUserLogin(status: boolean) {
    this.userloginSubject.next(status);
  }

  // tslint:disable-next-line:typedef
  getCartStatus() {
    return this.updateCartStatusSubject.asObservable();
  }

  setProduct(product: IProduct) {
    this.updateProductSubject.next(product);
  }

  getCart() {
    return this.updateCartSubject.asObservable();
  }

  // tslint:disable-next-line:typedef
  setCartStatus(status: ICItem) {
    this.updateCartStatusSubject.next(status);
  }

  setCart(status: boolean) {
    this.updateCartSubject.next(status);
  }


    getDiseaseId(){
        return this.updateDiseaseId.asObservable();
    }
    setDiseaseId(disease:any){
        this.updateDiseaseId.next(disease);
    }

    getSavecurrentLanguage(): string {
        const lng = localStorage.getItem('locale');
        if (lng) {
            return lng;
        }
        return 'mr';
    }

    getSliderConfig(numofSlidePerpage: number, ismobile: boolean, dots:boolean=false) {

        var slideConfig = {
            "slidesToShow": ismobile ? 1 : numofSlidePerpage,
            "slidesToScroll": 1,
            "dots": dots,
            "nextArrow": (ismobile) ? '' : '<div class="nav-btn next-slide"><i class="fa fa-angle-right" style="font-size:36px"></i></div>',
            "prevArrow": (ismobile) ? '' : '<div class="nav-btn prev-slide"><i class="fa fa-angle-left" style="font-size:36px"></i></div>',
            "arrows": !ismobile,
            "infinite": false,
            'responsive': [
                {
                    'breakpoint': 1024,
                    'settings': {
                        'slidesToShow': 4,
                        'slidesToScroll': 1,
                        'infinite': true,
                        'dots': dots,
                    },
                },
                {
                    'breakpoint': 600,
                    'settings': {
                        'slidesToShow': 3,
                        'slidesToScroll': 1,
                        'infinite': true,
                        'dots': dots,
                    },
                },
                {
                    'breakpoint': 480,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'infinite': true,
                        'dots': dots,
                    },
                },
            ]
        };

        return slideConfig;
    }

}
